import {
  RecordContextProvider,
  Show,
  useGetOne,
  useRecordContext,
} from "react-admin";
import CustomPaper from "../unit/CustomPaper";
import CustomTableContainer from "../unit/CustomTableContainer";
import CustomTable from "../unit/CustomTable";
import {
  Box,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import HmSubHeaderTitle from "../unit/HmSubHeaderTitle";
import Link from "@mui/material/Link";
import sendRequest from "../dataProvider/sendRequest";
import useNotify from "../unit/useNotify";
import React from "react";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import NoPermission from "../unit/NoPermission";
const DailyReportTableTitle = ({ ...props }) => {
  // const record = useRecordContext();
  // if (!record) return null;
  const reqDate = props?.reqDate;
  return (
    <>
      <Link
        href='/monthreport?filter={"status":"monthreport"}'
        sx={{
          display: "block",
          position: "absolute",
          top: "76px",
          left: "75px",
        }}
      >
        <Tooltip title="Return to List" placement="left">
          <ArrowCircleLeftIcon color="primary" sx={{ float: "right" }} />
        </Tooltip>
      </Link>
      <HmSubHeaderTitle
        title={`${
          reqDate ? reqDate : ""
        } Daily Activity: Click linked value to see details`}
        sx={{
          display: "block",
          position: "absolute",
          top: "70px",
          left: "115px",
        }}
      />
    </>
  );
};

// const generateDateArray = (monthStr: any) => {
//   const startDate = new Date(`${monthStr}-01`);
//   const endDate = new Date(
//     startDate.getFullYear(),
//     startDate.getMonth() + 1,
//     0
//   );

//   const dateArray = [];
//   const totalDays = endDate.getDate();

//   for (let day = 1; day <= totalDays; day++) {
//     const currentDate = new Date(
//       startDate.getFullYear(),
//       startDate.getMonth(),
//       day
//     );
//     const weekDay = currentDate.getDay();

//     dateArray.push({
//       date: {
//         day: day,
//         weekDay: ["S", "M", "T", "W", "T", "F", "S"][weekDay],
//         date: `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
//           .toString()
//           .padStart(2, "0")}-${day.toString().padStart(2, "0")}`,
//       },
//     });
//   }

//   return dateArray;
// };

const generateDateArray = (monthStr: string) => {
  const [year, month] = monthStr.split("-").map(Number);

  // 使用 UTC 时间创建日期
  const startDate = new Date(Date.UTC(year, month - 1, 1));
  const endDate = new Date(Date.UTC(year, month, 0));

  const dateArray = [];
  const totalDays = endDate.getUTCDate();

  for (let day = 1; day <= totalDays; day++) {
    const currentDate = new Date(Date.UTC(year, month - 1, day));
    const weekDay = currentDate.getUTCDay();

    dateArray.push({
      date: {
        day: day, // 使用循环的 day，而不是从日期对象获取
        weekDay: ["S", "M", "T", "W", "T", "F", "S"][weekDay],
        date: `${year}-${month.toString().padStart(2, "0")}-${day
          .toString()
          .padStart(2, "0")}`,
      },
    });
  }

  return dateArray;
};
const DailyReportTableBody = () => {
  const record = useRecordContext();
  if (!record) return null;
  const [loading, setLoading] = React.useState(true);
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const currentMonthDatacount = record?.currentMonthDatacount;
  const downloadDatacount = record?.downloadDatacount;
  const downloadDatacountArray = [];
  const totalSumData = record.data;
  const totalSumDataArray = [];
  for (const [key, value] of Object.entries(totalSumData)) {
    console.log(`${key}: ${value}`);
    totalSumDataArray.push({ reportName: key, total: value });
  }

  // console.log("totalSumDataArray", totalSumDataArray);

  // const startDate = new Date(`${record.id}-01`);
  // const endDate = new Date(startDate);
  // endDate.setMonth(endDate.getMonth() + 1);
  // endDate.setDate(0);
  // const dateArray: {
  //   date: { day: number; weekDay: string; date: string };
  // }[] = [];
  // for (let d = startDate; d <= endDate; d.setDate(d.getDate() + 1)) {
  //   const day = d.getDate();
  //   const weekDay = d.getDay();
  //   dateArray.push({
  //     date: {
  //       day: day,
  //       weekDay: ["S", "M", "T", "W", "T", "F", "S"][weekDay],
  //       date: `${d.getFullYear()}-${(d.getMonth() + 1)
  //         .toString()
  //         .padStart(2, "0")}-${day.toString().padStart(2, "0")}`,
  //     },
  //   });
  // }
  const dateArray = generateDateArray(record.id);
  const handleDownloadReport = async (title: string, path: string) => {
    // alert("title==>" + title);
    // alert("path==>" + path);
    setLoading(true);
    // try {
    //   const response = await sendRequest(
    //     `dailyreport/download`,
    //     { id: path },
    //     "get"
    //   );
    //   if (response) {
    //     //donwload xlsx file,xls, csv file
    //     const blob = new Blob([response], {
    //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    //     });
    //     const url = window.URL.createObjectURL(blob);
    //     const a = document.createElement("a");
    //     a.href = url;
    //     a.download = path.split("/").pop() || title;
    //     document.body.appendChild(a);
    //     a.click();
    //     document.body.removeChild(a);
    //     window.URL.revokeObjectURL(url);
    //     setLoading(false);
    //   } else {
    //     errorNotify("Failed to download report");
    //   }
    // } catch (error) {
    //   console.error("Download error:", error);
    //   errorNotify("Error downloading report");
    // }
    try {
      const access_token = localStorage.getItem("access_token");
      const csrfToken = localStorage.getItem("csrfToken");
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/dailyreport/download/${path}`,
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
            "X-CSRF-TOKEN": csrfToken ?? "",
            "X-XSRF-TOKEN": csrfToken ?? "",
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      console.log("report response:", data?.download_url);
      if (data?.download_url) {
        const a = document.createElement("a");
        a.href = data?.download_url;
        a.download = data?.filename;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();

        setTimeout(() => {
          document.body.removeChild(a);
        }, 100);
      } else {
        errorNotify("File not found");
      }
    } catch (error) {
      console.error("Error downloading attachment:", error);
    }
    setLoading(false);
  };
  return (
    <>
      <Box
        sx={{
          width: "calc(100vw - 95px)",
          height: "calc(100vh - 189px)",
          overflow: "auto",
          marginTop: "75px",
        }}
      >
        <CustomTableContainer
          component={CustomPaper}
          sx={{ background: "none" }}
        >
          <CustomTable
            stickyHeader
            id="table-loan-summary-current-schedule-list"
            sx={{ tableLayout: "fixed" }}
          >
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    position: "sticky",
                    left: 0,
                    backgroundColor: "#edf4fb",
                    zIndex: 1200,
                    //old style
                    "&.MuiTableCell-head": {
                      width: "150px !important",
                      maxWidth: "150px",
                      minWidth: "150px",
                    },
                  }}
                  className="hm-table-header"
                >
                  Activity
                </TableCell>
                <TableCell
                  sx={{
                    position: "sticky",
                    left: "150px",
                    backgroundColor: "#edf4fb",
                    zIndex: 1200,
                    //old style
                    "&.MuiTableCell-head": {
                      width: "80px !important",
                      maxWidth: "80px",
                      minWidth: "80px",
                    },
                  }}
                  className="hm-table-header"
                >
                  Total/Date
                </TableCell>
                {dateArray.map((item) => (
                  <TableCell
                    key={
                      item.date +
                      `_` +
                      Math.random().toString(36).substring(2, 15)
                    }
                    sx={{
                      "&.MuiTableCell-head": {
                        width: "80px !important",
                        maxWidth: "80px",
                        minWidth: "80px",
                        textAlign: "right",
                      },
                    }}
                  >
                    <span style={{ color: "gray" }}>{item.date.weekDay}</span>
                    <br />
                    {item.date.day}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {record == null ? (
                <TableRow>
                  <TableCell colSpan={8}>
                    There is no current payment record available.
                  </TableCell>
                </TableRow>
              ) : (
                <>
                  {totalSumDataArray &&
                    totalSumDataArray.length > 0 &&
                    totalSumDataArray.map((row: any) => (
                      <>
                        <TableRow key={row.reportName}>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              position: "sticky",
                              left: 0,
                              backgroundColor: "#edf4fb",
                              zIndex: 1100,
                              color: "gray",
                              //old style
                              textAlign: "left",
                              fontWeight: "bold",
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              maxWidth: "150px",
                              width: "150px",
                              minWidth: "150px",
                            }}
                          >
                            {/* {row.reportName} */}
                            {/*将reportName 里的Application 替换成 Applications
                            , 将BC User 替换成Customers
                            */}
                            {row.reportName
                              .replace("Application", "Applications")
                              .replace("BC User", "Customers")}
                          </TableCell>
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              position: "sticky",
                              left: "150px",
                              backgroundColor: "#edf4fb",
                              zIndex: 1100,
                              color: "gray",
                              //old style
                              textAlign: "left",
                              fontWeight: "bold",
                              whiteSpace: "normal",
                              wordWrap: "break-word",
                              maxWidth: "80px",
                              width: "80px",
                              minWidth: "80px",
                            }}
                          >
                            {row.total}
                          </TableCell>
                          {dateArray.map((item) => (
                            // 从currentMonthDatacount[reprot name][date]里取值
                            <TableCell
                              key={item.date + `_` + row.reportName}
                              sx={{ textAlign: "right", width: "60px" }}
                            >
                              {/* {item.date.date} */}
                              {
                                <span style={{ color: "gray" }}>
                                  {downloadDatacount &&
                                  downloadDatacount[row.reportName] &&
                                  downloadDatacount[row.reportName][
                                    item.date.date
                                  ] &&
                                  downloadDatacount[row.reportName][
                                    item.date.date
                                  ] !== undefined &&
                                  currentMonthDatacount[row.reportName][
                                    `${record.id}-${item.date.day
                                      .toString()
                                      .padStart(2, "0")}`
                                  ] !== undefined &&
                                  currentMonthDatacount[row.reportName][
                                    `${record.id}-${item.date.day
                                      .toString()
                                      .padStart(2, "0")}`
                                  ] != 0 ? (
                                    <Link
                                      // to={`/dailyreport/${
                                      //   downloadDatacount[row.reportName][
                                      //     item.date.date
                                      //   ]
                                      // }`}
                                      onClick={() => {
                                        const downloadId =
                                          downloadDatacount[row.reportName][
                                            item.date.date
                                          ];
                                        handleDownloadReport(
                                          row.reportName,
                                          "" + downloadId
                                        );
                                      }}
                                      sx={{
                                        "&.RaLink-link": {
                                          color: "#1976d2",
                                          textDecoration: "none",
                                        },
                                        "&.MuiLink-root": {
                                          color: "#1976d2",
                                          textDecoration: "none",
                                        },
                                        "&:hover": {
                                          textDecoration: "underline",
                                        },
                                        cursor: "pointer",
                                      }}
                                    >
                                      {currentMonthDatacount &&
                                      currentMonthDatacount[row.reportName] &&
                                      currentMonthDatacount[row.reportName][
                                        `${record.id}-${item.date.day
                                          .toString()
                                          .padStart(2, "0")}`
                                      ] !== undefined
                                        ? currentMonthDatacount[row.reportName][
                                            `${record.id}-${item.date.day
                                              .toString()
                                              .padStart(2, "0")}`
                                          ]
                                        : null}
                                    </Link>
                                  ) : (
                                    "-"
                                  )}
                                </span>
                              }
                            </TableCell>
                          ))}
                        </TableRow>
                      </>
                    ))}
                </>
              )}
              {/* <>
                    <TableRow>
                      <TableCell className="amountText">111</TableCell>
                      <TableCell className="amountText">222</TableCell>
                      {dateArray.map((item) => (
                        <TableCell key={item.date}>{item.date.day}</TableCell>
                      ))}
                    </TableRow>
                  </> */}
            </TableBody>
          </CustomTable>
        </CustomTableContainer>
      </Box>
    </>
  );
};
const DailyReportShow = () => {
  const permissions =
    localStorage.getItem("bbaccess")?.toString().split(",") || [];
  if (!permissions.includes("personal_reports")) {
    return <NoPermission />;
  }
  const urlParams = new URLSearchParams(window.location.search);
  // monthreportDetail/2025-08/show
  const reqDate = window.location.pathname.split("/")[2];
  console.log("DailyReportShow reqDate==>", reqDate);
  const {
    data: record,
    isLoading,
    error,
  } = useGetOne("monthreport", { id: reqDate });
  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  if (!record) return <div>No data found</div>;
  return (
    <>
      <RecordContextProvider value={record}>
        <DailyReportTableTitle reqDate={reqDate} />
        <DailyReportTableBody />
      </RecordContextProvider>
    </>
  );
};
export default DailyReportShow;
